import React from "react";

const LeftPaneText = () => {
  const handleClick = () => {
    window.open("https://thetotoapp.herokuapp.com/");
  };
  return (
    <div className="leftPane">
      <h1>The Toto App</h1>
      <p>
        Toto is a data analysis desktop and mobile progressive web app that help
        users find the basic cost of living and quality of life information of a
        new city that they are considering relocating to.
      </p>
      <p>
        The toto app was created in a team of 4 full stack developers. The
        features that were developed that allowed for a user to be able to do
        the following:
      </p>
      <h3>Features</h3>
      <ul>
        <li>
          allows the user to list cities based on specific metrics for low-rent,
          healthcare, daycare cost, and transportation
        </li>
        <li>select and compare 3 different cities side by side</li>
        <li>create an account and bookmark</li>
      </ul>
      <h3>Technolgies</h3>
      <ul>
        <li>React.js</li>
        <li>Bootstrap</li>
        <li>Redux</li>
        <li>Chart.js</li>
        <li>Postgres</li>
        <li>Node.js</li>
      </ul>
      <button onClick={handleClick}>SEE LIVE WEBSITE</button>
    </div>
  );
};

export default LeftPaneText;
